var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 50,
    viewBox: "0 0 103 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 101.51,
    height: 49,
    fill: "#D9D9D9",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_168)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.99805,
    y: 16.5431,
    width: 106.581,
    height: 33.4464,
    fill: "#D5E5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.57607 6.02878L-1.55204 5.68687C0.483935 5.35586 4.53199 4.67205 8.5676 3.96593C12.6027 3.24842 16.6248 2.4972 20.6839 2.31569C24.7429 2.13418 28.8389 2.52238 32.9591 3.19518C37.0793 3.86799 41.2008 4.82641 45.2869 5.24934C49.3735 5.68367 53.4242 5.5711 57.4934 5.61768C61.5627 5.66426 65.6505 5.86999 69.7044 5.06021C73.7583 4.25044 77.7553 2.42618 81.7813 1.50338C85.8072 0.580583 89.8619 0.559248 93.9445 0.902343C98.0275 1.25684 102.139 1.98718 104.206 2.35184L106.262 2.717L107.021 19.7096L104.986 19.8006C102.939 19.8922 98.8689 20.0742 94.8099 20.2557C90.7508 20.4372 86.7032 20.6182 82.6441 20.7997C78.5851 20.9812 74.5146 21.1632 70.4326 21.3458C66.3507 21.5283 62.2802 21.7103 58.2212 21.8918C54.1621 22.0733 50.1145 22.2543 46.0554 22.4358C41.9963 22.6173 37.9258 22.7994 33.8439 22.9819C29.762 23.1644 25.6915 23.3464 21.6324 23.5279C17.5734 23.7095 13.5257 23.8905 9.46667 24.072C5.40761 24.2535 1.33712 24.4355 -0.709566 24.527L-2.74481 24.618L-3.57607 6.02878Z",
    fill: "#D5E5EF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern1);
export default __webpack_public_path__ + "static/media/pattern1.57309475ae02911cd37fd2ee8d0cc6f4.svg";
export { ForwardRef as ReactComponent };